import { createSlice } from '@reduxjs/toolkit';
import { CallAuditState } from './interface';

const initialState: CallAuditState = {
  isTableLoading: false,
  isFeedbackSubmitting: false,
  isSidebarLoading: false,
  auditData: [],
  qcAgentAudits: [],
  totalElements: 0,
  pageNumber: 0,
  currentPage: 0,
  pageSize: 20,
  totalPages: 0,
  callingAgentAudits: [],
  callingAgentAuditDetails: null,
  qcAgentFilters: null,
  qcTeamLeadFilters: null,
  selectedAuditAssignmentReferenceId: null
};

const callAuditSlice = createSlice({
  name: 'callAudit',
  initialState,
  reducers: {
    setIsTableLoading: (state, action) => {
      state.isTableLoading = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setTotalElements: (state, action) => {
      state.totalElements = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setQcAgentAudits: (state, action) => {
      state.qcAgentAudits = action.payload;
    },
    setCallingAgentAudits: (state, action) => {
      state.callingAgentAudits = action.payload;
    },
    setCallingAgentAuditDetails: (state, action) => {
      state.callingAgentAuditDetails = action.payload;
    },
    updateCallingAgentAuditDetails: (state, action) => {
      // Only update specific fields (auditConfig, auditStatus, auditTrail) while preserving others
      if (state.callingAgentAuditDetails) {
        state.callingAgentAuditDetails = {
          ...state.callingAgentAuditDetails,
          auditConfig: action.payload.auditConfig ?? state.callingAgentAuditDetails.auditConfig,
          auditStatus: action.payload.auditStatus ?? state.callingAgentAuditDetails.auditStatus,
          auditTrail: action.payload.auditTrail ?? state.callingAgentAuditDetails.auditTrail
        };
      }
    },
    setQcAgentFilters: (state, action) => {
      state.qcAgentFilters = action.payload;
    },
    setQcTeamLeadFilters: (state, action) => {
      state.qcTeamLeadFilters = action.payload;
    },
    setSelectedAuditAssignmentReferenceId: (state, action) => {
      state.selectedAuditAssignmentReferenceId = action.payload;
    },
    setIsSidebarLoading: (state, action) => {
      state.isSidebarLoading = action.payload;
    },
    setIsFeedbackSubmitting: (state, action) => {
      state.isFeedbackSubmitting = action.payload;
    }
  }
});

export const {
  setIsTableLoading,
  setCurrentPage,
  setPageSize,
  setTotalElements,
  setTotalPages,
  setQcAgentAudits,
  setCallingAgentAudits,
  setCallingAgentAuditDetails,
  updateCallingAgentAuditDetails,
  setQcAgentFilters,
  setQcTeamLeadFilters,
  setSelectedAuditAssignmentReferenceId,
  setIsSidebarLoading,
  setIsFeedbackSubmitting
} = callAuditSlice.actions;

export default callAuditSlice.reducer;
